var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgradecimiento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 598.597,
    height: 415.702,
    viewBox: "0 0 598.597 415.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat_bot_Live_testing",
    "data-name": "Chat bot_Live testing",
    transform: "translate(-0.407 -25.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M519.215,26.3A170.234,170.234,0,0,0,284.4,79.386l-28.133,44.557a33,33,0,0,1-56.557-1.23h0A106.9,106.9,0,1,0,58.565,271.138l118.552,60.135a91.552,91.552,0,0,0,41.063,9.765l34.35-.09,176.258-.465c55.867-.577,111.457-28.6,143.5-79.365A170.217,170.217,0,0,0,519.215,26.3Z",
    transform: "translate(0.407 53.672)",
    fill: "#b4d9f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(69.75 324.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M93.5,114.533H8.6a8.6,8.6,0,0,1-8.6-8.6V8.6A8.6,8.6,0,0,1,8.6,0H93.5a8.6,8.6,0,0,1,8.6,8.6V105.93A8.6,8.6,0,0,1,93.5,114.533Z",
    transform: "translate(0.488 0.052)",
    fill: "#4eb5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M57.99,114.533H8.6a8.6,8.6,0,0,1-8.6-8.6V8.6A8.6,8.6,0,0,1,8.6,0H57.99a8.6,8.6,0,0,1,8.6,8.6V105.93A8.6,8.6,0,0,1,57.99,114.533Z",
    transform: "translate(0.488 0.052)",
    fill: "none",
    stroke: "#01d2df",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(71.25 14.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M0,.375H26.827",
    transform: "translate(0.57 0.075)",
    fill: "none",
    stroke: "#fff7ee",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M0,.375H26.827",
    transform: "translate(0.57 85.313)",
    fill: "none",
    stroke: "#fff7ee",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group",
    transform: "translate(7.5 14.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.682,
    cy: 3.682,
    r: 3.682,
    transform: "translate(0.375 0.03)",
    fill: "none",
    stroke: "#b4d9f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M0,.375H40.057",
    transform: "translate(12.142 3.338)",
    fill: "none",
    stroke: "#b4d9f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    "data-name": "Group",
    transform: "translate(0 23.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 3.682,
    cy: 3.682,
    r: 3.682,
    transform: "translate(0.375 0.195)",
    fill: "none",
    stroke: "#b4d9f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M0,.375H40.057",
    transform: "translate(12.142 3.503)",
    fill: "none",
    stroke: "#b4d9f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    "data-name": "Group",
    transform: "translate(0 46.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    "data-name": "Oval",
    cx: 3.682,
    cy: 3.682,
    r: 3.682,
    transform: "translate(0.375 0.36)",
    fill: "none",
    stroke: "#b4d9f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M0,.375H40.057",
    transform: "translate(12.142 3.668)",
    fill: "none",
    stroke: "#b4d9f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    "data-name": "Group",
    transform: "translate(0 69.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    "data-name": "Oval",
    cx: 3.682,
    cy: 3.682,
    r: 3.682,
    transform: "translate(0.375 0.533)",
    fill: "none",
    stroke: "#b4d9f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    d: "M0,.375H40.057",
    transform: "translate(12.142 3.84)",
    fill: "none",
    stroke: "#b4d9f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    "data-name": "Group",
    transform: "translate(0 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    d: "M0,.375H51.825",
    transform: "translate(0.375 0.48)",
    fill: "none",
    stroke: "#94c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    "data-name": "Path",
    d: "M0,.375H51.825",
    transform: "translate(0.375 23.903)",
    fill: "none",
    stroke: "#94c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    "data-name": "Path",
    d: "M0,.375H51.825",
    transform: "translate(0.375 47.318)",
    fill: "none",
    stroke: "#94c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    "data-name": "Path",
    d: "M0,.375H51.825",
    transform: "translate(0.375 70.732)",
    fill: "none",
    stroke: "#94c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    "data-name": "Path",
    d: "M0,.375H557.31",
    transform: "translate(18.788 439.185)",
    fill: "none",
    stroke: "#94c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    "data-name": "Group",
    transform: "translate(225 26.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-15",
    "data-name": "Path",
    d: "M191.648,412.853H23.827A23.829,23.829,0,0,1,0,389.025V23.827A23.829,23.829,0,0,1,23.827,0h167.82a23.829,23.829,0,0,1,23.827,23.827v365.19A23.835,23.835,0,0,1,191.648,412.853Z",
    transform: "translate(0.563 0.233)",
    fill: "#fff",
    stroke: "#01d2df",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    "data-name": "Path",
    d: "M14.828,394.853A14.845,14.845,0,0,1,0,380.025V14.828A14.845,14.845,0,0,1,14.828,0h167.82a14.845,14.845,0,0,1,14.827,14.828v365.19a14.845,14.845,0,0,1-14.827,14.828H14.828Z",
    transform: "translate(9.563 9.233)",
    fill: "#cdf7f9",
    stroke: "#64bab7",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    "data-name": "Path",
    d: "M71.34,0,68.895,9.038H2.445L0,0C-.007,0,71.385.045,71.34,0Z",
    transform: "translate(72.63 9.233)",
    fill: "#fff",
    stroke: "#01d2df",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    "data-name": "Oval",
    cx: 34.605,
    cy: 34.605,
    r: 34.605,
    transform: "translate(73.695 44.737)",
    fill: "#e2424e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-18",
    "data-name": "Path",
    d: "M103.043,21.007H4.56A4.558,4.558,0,0,1,0,16.448V4.56A4.558,4.558,0,0,1,4.56,0h98.483a4.558,4.558,0,0,1,4.56,4.56V16.448A4.558,4.558,0,0,1,103.043,21.007Z",
    transform: "translate(54.877 147.225)",
    fill: "#4eb5ea"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    "data-name": "Oval",
    cx: 11.01,
    cy: 11.01,
    r: 11.01,
    transform: "translate(174.158 146.715)",
    fill: "#4eb5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-19",
    "data-name": "Path",
    d: "M4.56,21.007H88.605a4.558,4.558,0,0,0,4.56-4.56V4.56A4.558,4.558,0,0,0,88.605,0H4.56A4.558,4.558,0,0,0,0,4.56V16.448A4.563,4.563,0,0,0,4.56,21.007Z",
    transform: "translate(54.765 177.982)",
    fill: "#01d2df"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-7",
    "data-name": "Oval",
    cx: 11.01,
    cy: 11.01,
    r: 11.01,
    transform: "translate(21.067 177.473)",
    fill: "#01d2df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-20",
    "data-name": "Path",
    d: "M70.485,21H4.56A4.558,4.558,0,0,1,0,16.44V4.56A4.558,4.558,0,0,1,4.56,0H70.485a4.558,4.558,0,0,1,4.56,4.56V16.448A4.552,4.552,0,0,1,70.485,21Z",
    transform: "translate(87.435 208.74)",
    fill: "#4eb5ea"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-8",
    "data-name": "Oval",
    cx: 11.01,
    cy: 11.01,
    r: 11.01,
    transform: "translate(174.158 208.23)",
    fill: "#4eb5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-21",
    "data-name": "Path",
    d: "M4.56,21.007h98.227a4.558,4.558,0,0,0,4.56-4.56V4.56A4.558,4.558,0,0,0,102.787,0H4.56A4.558,4.558,0,0,0,0,4.56V16.448A4.558,4.558,0,0,0,4.56,21.007Z",
    transform: "translate(54.765 239.49)",
    fill: "#01d2df"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-9",
    "data-name": "Oval",
    cx: 11.01,
    cy: 11.01,
    r: 11.01,
    transform: "translate(21.067 238.988)",
    fill: "#01d2df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-22",
    "data-name": "Path",
    d: "M102.7,21.007H4.56A4.558,4.558,0,0,1,0,16.448V4.56A4.558,4.558,0,0,1,4.56,0H102.7a4.558,4.558,0,0,1,4.56,4.56V16.448A4.553,4.553,0,0,1,102.7,21.007Z",
    transform: "translate(55.222 270.247)",
    fill: "#4eb5ea"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    "data-name": "Oval",
    cx: 11.01,
    cy: 11.01,
    r: 11.01,
    transform: "translate(174.158 269.745)",
    fill: "#4eb5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-23",
    "data-name": "Path",
    d: "M4.56,21.007H76.71a4.558,4.558,0,0,0,4.56-4.56V4.56A4.558,4.558,0,0,0,76.71,0H4.56A4.558,4.558,0,0,0,0,4.56V16.448A4.558,4.558,0,0,0,4.56,21.007Z",
    transform: "translate(54.765 301.005)",
    fill: "#01d2df"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-11",
    "data-name": "Oval",
    cx: 11.01,
    cy: 11.01,
    r: 11.01,
    transform: "translate(21.067 300.503)",
    fill: "#01d2df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-24",
    "data-name": "Path",
    d: "M129.45,20.445H10.222A10.22,10.22,0,0,1,0,10.222H0A10.22,10.22,0,0,1,10.222,0H129.45a10.22,10.22,0,0,1,10.223,10.222h0A10.22,10.22,0,0,1,129.45,20.445Z",
    transform: "translate(22.95 367.432)",
    fill: "none",
    stroke: "#64bab7",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-25",
    "data-name": "Path",
    d: "M16.563,33.909a4.494,4.494,0,0,1-3.15-1.283l-12.06-11.8a4.5,4.5,0,0,1,6.293-6.435l8.97,8.775L39.948,1.224a4.5,4.5,0,0,1,6.165,6.555l-26.475,24.9A4.468,4.468,0,0,1,16.563,33.909Z",
    transform: "translate(83.674 64.881)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    "data-name": "Group",
    transform: "translate(70.5 118.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-26",
    "data-name": "Path",
    d: "M25.64.014c10.043-.4,19.043,7.59,21.165,17.273,1.575,7.185-1.9,30.46,2.006,34.728C53.085,56.4,56.35,82.264,54.79,84.634c-3.54,5.37-9.162-18.417-25-16.985C12.035,69.254.65,56.137.163,43.589S-1.4,1.079,25.64.014Z",
    transform: "translate(27.88 0.098)",
    fill: "#123281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-27",
    "data-name": "Path",
    d: "M43.345,0,22.39,6.4S17.583,9.1,16.36,14.085L1.548,57.465S-1.16,62.618.588,66.2,4.7,70.575,4.7,70.575,5.658,62.272,8.89,60s8.91-3.06,8.91-3.06L16.885,54.4l8.648-20.752L33.22,66.42,28.593,79.613l51.99-.878.128-19L81.978,52.4s4.11,14.8,7.778,17.513,9.09,5.34,15.12-2.22c0,0-16.778-59.115-21.757-61.56S69.048,1.32,69.048,1.32s-4.372,9.435-12.4,8.565S43.345,0,43.345,0Z",
    transform: "translate(0.62 62.655)",
    fill: "#cdf7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-28",
    "data-name": "Path",
    d: "M27.263.517l.262,8.91a4.828,4.828,0,0,1,2.445,1.658,5.635,5.635,0,0,1,.96,2.28L88.762,27.038a10.49,10.49,0,0,1,7.882,12.2L81.262,118.478H68.94s-6.555-59.243,4.192-69.2L0,35.385V0Z",
    transform: "translate(54.202 141.548)",
    fill: "#123281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-29",
    "data-name": "Path",
    d: "M40.365,22.718s73.132,18.09,74.708,22.02-15.728,93.585-15.728,93.585H90.7s-2.88-42.99-3.93-52.687,4.98-17.827,4.98-17.827S50.07,67.283,31.98,65.97,0,48.93,0,33.728C0,15.375,10.485,0,10.485,0h30.4Z",
    transform: "translate(18.817 141.105)",
    fill: "#123281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-30",
    "data-name": "Path",
    d: "M0,0,49.943,15.623a9.087,9.087,0,0,1,6.263,10.065l-8.67,55.747",
    transform: "translate(76.485 167.88)",
    fill: "none",
    stroke: "#01d2df",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-31",
    "data-name": "Path",
    d: "M19.522,2.453,15.007,30.135l8.715,7.29,5.325,1.522a2.2,2.2,0,0,1,1.59,2.34h0a2.209,2.209,0,0,1-2.01,1.98l-6.533.532L0,40.05,5.325,0Z",
    transform: "translate(117.045 251.572)",
    fill: "#e2424e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-32",
    "data-name": "Path",
    d: "M15.192.241c9.765-1.357,17.16,3.113,19.6,10.972,2.265,7.3.42,17.347.952,21.495.757,5.925-6.488,16.553-11.228,17.16-5.61.72-15.668-4.792-19.08-10.252A35.352,35.352,0,0,1,.927,12.976C2.465,6.631,9.515,1.029,15.192.241Z",
    transform: "translate(35.98 5.654)",
    fill: "#ffc17c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-33",
    "data-name": "Path",
    d: "M18.015,2.64v8.242l7.538,2.49s-2.3,9.375-11.4,8.715S0,12.435,0,12.435l4.125-1.253S4.387,0,4.582,0,18.015,2.64,18.015,2.64Z",
    transform: "translate(43.725 50.385)",
    fill: "#ffc17c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-34",
    "data-name": "Path",
    d: "M2.535,9.192s5.88,16.425,25.65,14.693c0,0,2.468-12.038-4.05-18.428C13.613-4.855,0,2.615,0,2.615Z",
    transform: "translate(45.045 4.69)",
    fill: "#123281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-35",
    "data-name": "Path",
    d: "M13.875,6.2S13.635,18.1,1.538,25.763c0,0-3.818-8.858.578-16.778C6.488,1.117,10.838,0,10.838,0Z",
    transform: "translate(34.215 7.298)",
    fill: "#123281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-36",
    "data-name": "Path",
    d: "M51.645,0s2.88,13.627,3.4,16.778-3.015,26.475-3.015,26.475l.127,19.4H0",
    transform: "translate(29.295 79.155)",
    fill: "none",
    stroke: "#94c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-37",
    "data-name": "Path",
    d: "M2.408,45.007S8,35.745,7.3,31.725C6.78,28.733,2.017,8.265,0,0",
    transform: "translate(26.542 96.795)",
    fill: "none",
    stroke: "#94c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-38",
    "data-name": "Path",
    d: "M.6,0S-2.2,13.627,4.27,15.03s15.9-6.99,15.9-6.99,8.213,11.01,13.98,8.385S36.775,2.8,36.775,2.8",
    transform: "translate(37.438 65.52)",
    fill: "none",
    stroke: "#94c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-39",
    "data-name": "Path",
    d: "M2.265,0s2.28,2.58,1.86,3.855C3.622,5.385,0,5.505,0,5.505",
    transform: "translate(61.26 35.798)",
    fill: "none",
    stroke: "#1b004f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-40",
    "data-name": "Path",
    d: "M0,0S1.3,4.005,6.488,4.1",
    transform: "translate(53.205 43.748)",
    fill: "none",
    stroke: "#1b004f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-41",
    "data-name": "Path",
    d: "M9.49,12.451A16.379,16.379,0,0,1,4.307,9.946C1.247,7.666-1.408,3.571.835,1.036c2.452-2.768,5.933.885,5.933.885Z",
    transform: "translate(30.725 29.751)",
    fill: "#ffc17c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-42",
    "data-name": "Path",
    d: "M29.622,25.952c-13.47,1.267-20.94-13.47-20.94-13.47a16.789,16.789,0,0,1-5.07-2.46C.965,8.094-1.345,3.8.92,1.277,4.347-2.533,8.3,3.4,8.3,3.4",
    transform: "translate(30.873 29.571)",
    fill: "none",
    stroke: "#1b004f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-43",
    "data-name": "Path",
    d: "M42.221,37.221C25.564,26.939,16.691,23.189.034,12.906c-.045-.5-.518-6.443,4.178-10.3A12.05,12.05,0,0,1,13.241.1c14.707,12.57,21.63,18.608,36.33,31.178Z",
    transform: "translate(4.639 119.214)",
    fill: "#ffc17c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-44",
    "data-name": "Path",
    d: "M26.947,30.36l-10,23.767s1.207,1.478.915,2.228-1.965.5-3.54.735c-3.2.472-5.332,2.865-6.225,3.87C4.612,64.86,5.039,70,5.144,71.033c0,0-4.852-2.625-5.115-6.945-.24-4.005,1.05-4.328,2.362-9.045S16.109,15.2,16.109,15.2c.877-4.373,4.545-8.213,7.868-9.263S43.552,0,43.552,0s5.332,9.743,13.89,9.743,11.4-8.715,11.4-8.715,11.58,3.165,13.327,4.125,6.338,12.712,6.338,12.712L99.472,49.717l5.595,17.91A9.835,9.835,0,0,1,96.5,73.043c-9.7.21-14.333-20.708-14.333-20.708h0",
    transform: "translate(0.428 62.722)",
    fill: "none",
    stroke: "#94c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-12",
    "data-name": "Oval",
    cx: 1.673,
    cy: 1.673,
    r: 1.673,
    transform: "translate(47.778 34.283) rotate(-74.616)",
    fill: "#1b004f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-13",
    "data-name": "Oval",
    cx: 1.673,
    cy: 1.673,
    r: 1.673,
    transform: "translate(65.062 32.69) rotate(-74.616)",
    fill: "#1b004f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-45",
    "data-name": "Path",
    d: "M14.422.007l.263,28.05,9.825,5.7,5.5.592a2.2,2.2,0,0,1,1.965,2.033h0a2.2,2.2,0,0,1-1.65,2.287l-6.345,1.635-22.41.068L0,0H14.422Z",
    transform: "translate(106.103 268.672)",
    fill: "#e2424e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-46",
    "data-name": "Path",
    d: "M0,50.492,23.76,2.3A3.887,3.887,0,0,1,27.21.137c7.26-.053,29.033-.21,36.4-.1A1.575,1.575,0,0,1,65,2.32L42.735,47.47a5.4,5.4,0,0,1-4.845,3.015H0Z",
    transform: "translate(98.152 119.975)",
    fill: "#4962ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-47",
    "data-name": "Path",
    d: "M36.7,2.97H1.778A1.776,1.776,0,0,1,0,1.192V0H39.495Z",
    transform: "translate(61.455 167.497)",
    fill: "#4962ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-48",
    "data-name": "Path",
    d: "M5.625,0,30.4,4.718,38.655,10.1l2.07,5.985a1.591,1.591,0,0,1-1.493,2.108l-4,.022a2.333,2.333,0,0,1-2.167-1.417L31.935,14.2l-3.45-2.227,2.137,2.318-.03,2.977a1.033,1.033,0,0,1-1.005,1.02h0a1.033,1.033,0,0,1-1.042-.847l-.5-2.76L23.858,12.45l-10.177.72a9.324,9.324,0,0,1-5.243-1.185L0,7.207Z",
    transform: "translate(46.875 149.227)",
    fill: "#ffc17c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-49",
    "data-name": "Path",
    d: "M3.548,52.524,12.758,23.5l.315-7.815a24.857,24.857,0,0,1,1.185-6.66l1.507-4.7L15.833.8a.813.813,0,0,1,1.14-.727l.015.008a4.591,4.591,0,0,1,2.76,3.788,5.89,5.89,0,0,1-.42,2.835l.368,3.923,8.647-4.17a1.786,1.786,0,0,1,2.3,2.543l-.548.892,1.373,1.005,1.875,9.562a3.546,3.546,0,0,1-1.86,4.043,51.819,51.819,0,0,1-5.573,3.142,15.717,15.717,0,0,1-4.5,1.432l-8.1,38.438c-.555,2.865-2.115,7.642-4.47,9.367-1.92,1.41-4.41,2.25-7.125.705a32.171,32.171,0,0,1,1.83-25.057Z",
    transform: "translate(94.597 58.108)",
    fill: "#ffc17c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-50",
    "data-name": "Path",
    d: "M.931,0a1.882,1.882,0,0,0-.9,1.95,1.872,1.872,0,0,0,1.747,1.5,2.1,2.1,0,0,0-1,2.5,2.086,2.086,0,0,0,1.9,1.35,2.41,2.41,0,0,0-.7,2.1,2.31,2.31,0,0,0,1.5,1.748,2.347,2.347,0,0,0,1.3,4.05",
    transform: "translate(114.134 68.993)",
    fill: "none",
    stroke: "#1b004f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-51",
    "data-name": "Path",
    d: "M4.022,0A33.444,33.444,0,0,0,1.4,25.515",
    transform: "translate(94.565 109.425)",
    fill: "none",
    stroke: "#94c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-52",
    "data-name": "Path",
    d: "M19.747,0,0,40.537",
    transform: "translate(105.495 124.545)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    "data-name": "Group",
    transform: "translate(420.75 101.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-53",
    "data-name": "Path",
    d: "M100.027,54.525H7.972A7.973,7.973,0,0,1,0,46.553V7.972A7.973,7.973,0,0,1,7.972,0h92.055A7.973,7.973,0,0,1,108,7.972v38.58A7.973,7.973,0,0,1,100.027,54.525Z",
    transform: "translate(0.428 0.21)",
    fill: "#cdf7f9",
    stroke: "#64bab7",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    "data-name": "Group",
    transform: "translate(12 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-54",
    "data-name": "Path",
    d: "M3.848,8.28h48.4a3.851,3.851,0,0,0,3.847-3.847V3.848A3.851,3.851,0,0,0,52.245,0H3.848A3.851,3.851,0,0,0,0,3.848v.585A3.851,3.851,0,0,0,3.848,8.28Z",
    transform: "translate(0.712 0.428)",
    fill: "#4eb5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-55",
    "data-name": "Path",
    d: "M3.848,8.28h14A3.851,3.851,0,0,0,21.69,4.432V3.848A3.851,3.851,0,0,0,17.843,0h-14A3.851,3.851,0,0,0,0,3.848v.585A3.855,3.855,0,0,0,3.848,8.28Z",
    transform: "translate(61.987 0.428)",
    fill: "none",
    stroke: "#01d2df",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-56",
    "data-name": "Path",
    d: "M3.848,8.28H79.582A3.851,3.851,0,0,0,83.43,4.432V3.848A3.851,3.851,0,0,0,79.582,0H3.848A3.851,3.851,0,0,0,0,3.848v.585A3.846,3.846,0,0,0,3.848,8.28Z",
    transform: "translate(0.712 28.23)",
    fill: "none",
    stroke: "#01d2df",
    strokeMiterlimit: 10,
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-57",
    "data-name": "Path",
    d: "M3.848,8.28H50.325a3.851,3.851,0,0,0,3.847-3.847V3.848A3.851,3.851,0,0,0,50.325,0H3.848A3.851,3.851,0,0,0,0,3.848v.585A3.846,3.846,0,0,0,3.848,8.28Z",
    transform: "translate(29.97 14.325)",
    fill: "#4eb5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-58",
    "data-name": "Path",
    d: "M3.848,8.28h18.24a3.851,3.851,0,0,0,3.847-3.847V3.848A3.851,3.851,0,0,0,22.087,0H3.848A3.851,3.851,0,0,0,0,3.848v.585A3.846,3.846,0,0,0,3.848,8.28Z",
    transform: "translate(0.712 14.325)",
    fill: "#4eb5ea"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgradecimiento);
export default __webpack_public_path__ + "static/media/agradecimiento.1b6710ca6e2a14fb98caa3daaf432c78.svg";
export { ForwardRef as ReactComponent };